import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PdfBulkDownloadService {

  constructor(private http: HttpClient) {}

  downloadS3(baseUrl: string, bulkPdfEngineUrl: string, s3Url: string, ssoId: string): Observable<any> {
    // First get the API token
    const apiTokenUrl = `${baseUrl}/getAPIAuthToken`;
    
    return this.http.get<any>(apiTokenUrl, { withCredentials: true }).pipe(
      map((response) => {
        console.log('API Token response:', response);
        
        // Build the download URL with all required parameters
        const clientKey = sessionStorage.getItem('client_key') || '';
        const apiToken = encodeURIComponent(response.apiToken);
        
        const downloadUrl = `${bulkPdfEngineUrl}/downloadBulkExportFileFromS3Url?s3_url=${s3Url}&client_key=${clientKey}&apiToken=${apiToken}&georaclehrid=${ssoId}`;
        
        // Open the download URL in a new window
        window.open(downloadUrl, '_blank');
        
        return response;
      })
    );
  }
}
